import { configureStore, ThunkAction, Action, Reducer } from "@reduxjs/toolkit";
import { reduxStoreConfig } from "../../site/configuration/reduxStoreConfig";

const reducer: { [key: string]: Reducer } = {};
for (const property in reduxStoreConfig) {
  reducer[property] = (reduxStoreConfig as any)[property].reducer;
}
export const store = configureStore({
  reducer: reducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
